export default [
  {
    path: 'paket-item',
    redirect: { name: 'itempackages' },
    component: { template: '<router-view />' },
    children: [
      {
        path: '/',
        name: 'itempackages',
        component: () => import('@pages/itempackages/Index.vue'),
        meta: {
          auth:true,
          pageTitle: 'Paket Item',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Paket Item',
              active: true
            },
          ],
        }
      },
      {
        path: 'tambah',
        name: 'itempackages-add',
        component: () => import('@pages/itempackages/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Tambah Paket Item',
          navActiveLink:'itempackages',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Paket Item',
              to: { name: 'itempackages' },
            },
            {
              text: 'Tambah',
              active: true
            },
          ],
        }
      },
      {
        path: ':id',
        name: 'itempackages-edit',
        component: () => import('@pages/itempackages/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Edit Paket Item',
          navActiveLink:'itempackages',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Paket Item',
              to: { name: 'itempackages' },
            },
            {
              text: 'Edit',
              active: true
            },
          ],
        }
      }
    ]
  }
]